import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE } from 'src/app/constants/preset-element-actions';
import { Lang, ReferenceParams, Res } from 'src/app/models';
import { DialogModalService, LanguageService, NotificationService, ValidatorsService} from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';
import { ApiPresetsService } from 'src/app/services/api-presets.service';
import { RereferencesActionsComponent } from '../../references/rereferences-actions/rereferences-actions.component';
import { AttributesGroupsActionsComponent } from '../attributes-groups-actions/attributes-groups-actions.component';
import { AttributesActionsValidator } from './attributes-actions.validator';

@Component({
  selector: 'app-attributes-actions',
  templateUrl: './attributes-actions.component.html',
  styleUrls: ['./attributes-actions.component.css']
})
export class AttributesActionsComponent implements OnInit {

  dataTest: any [] = [
    {
      key: 'test',
      name: 'test'
    }
  ]

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  attrId: string;
  language: string;
  loading: boolean;
  attributeName: Lang;
  referenceControl: boolean = false;
  attributeTypeControl: boolean = false;
  attributePresentationTypes: any = ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE;
  attributeValueTypes: any [] = [];
  attributeGroups: any;
  getDirectory: any;
  attrEditable: boolean;
  mandatory: boolean;
  translation: boolean;
  errorMessages: any;

  test: any = false;

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id:                   [''],
    name:                 [''],
    attribute_group_id:   [null, this.validator.attribute_group_id],
    attr_present_type_id: [null, this.validator.attr_present_type_id],
    attribute_value_type: [null, this.validator.attribute_value_type],
    attr_reference_id:    [null], //, this.validator.attr_reference_id
    translation:          [null],
    mandatory:            [null]
  });

  // create
  @Input() set data(value) {

    if (value != null) {

     this.attrId = value.attr_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiAttributesService: ApiAttributesService,
    public activeModal: NgbActiveModal,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private apiPresets: ApiPresetsService,
    private validator: AttributesActionsValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;


    if (this.attrId) {
      this.form.controls.id.setValue(this.attrId);
      this.onEdit();
    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    // еслии в справочнике выбран 'COMBOBOX' показываем справочник
    this.form.get('attr_present_type_id').valueChanges.subscribe(val => {
      
      if(val == 'COMBOBOX' || val == 'COMBOBOX_MULTIPLE') {

        this.referenceControl = true;
      } else {

        this.referenceControl = false;
      }
    })

    // 
    this.form.get('attr_present_type_id').valueChanges.subscribe(val => {

      this.getValueType(val);
      this.form.get('attribute_value_type').setValue(null);
      
      if(val == 'INPUT' || val == 'TEXTAREA') {

        this.test = true;
      } else {

        this.test = false;
      }
    })

    // 
    this.form.get('attribute_value_type').valueChanges.subscribe(val => {
      
      if(val == 'STRING') {

        this.attributeTypeControl = true;
      } else {

        this.attributeTypeControl = false;
      }
    })

    this.getAttributeGroup();
    this.getReferences();
  }


  /**
   * 
   * @param data 
   */
  initForm(data) {

    this.form.setValue({
      id:                   data.id,
      name:                 data.name.ru,
      attribute_group_id:   data.attr_group_id,
      attr_present_type_id: data.attr_present_type_id,
      attribute_value_type: data.attribute_value_type,
      attr_reference_id:    data.ref_id,
      translation:          data.translation,
      mandatory:            data. mandatory
    })
  }


  /**
   * 
   */
  getValueType(attr_present_type_id): void {

    let params = {
      attr_present_type_id: attr_present_type_id
    }

    this.subscriptions.add(
      this.apiPresets.getAttrPresentTypeId(params).subscribe((response: any) => {
        
        if (response.result != null) {

          this.attributeValueTypes = response.result;
        }
      })
    );
  }


  /**
  * 
  * @param fieldName string
  * @param value Lang
  */
   eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }


  /**
   * 
   */
   setDataInForm(data: any): any {

    this.attributeName = data.name;
  }


  /**
   * 
   */
  referencesCreate() {

    let data = {
      id: ''
    }

    this.dialogModal.open(data, RereferencesActionsComponent).then(
      (result) => {

        if (result) {

          this.getReferences();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  attributesGroups() {

    let data = {
      group_id: ''
    }

    this.dialogModal.open(data, AttributesGroupsActionsComponent).then(
      (result) => {
        
        if (result) {
        
          this.getAttributeGroup();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  getAttributeGroup(): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeGroups = response.result;
          console.log('attributeGroups', this.attributeGroups);
          
        }
      })
    );
  }


  /**
   * 
   */
  getReferences(): void {

    let params: ReferenceParams = {
      ref_name: 'references',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.getDirectory = response.result;
          console.log('getDirectory', this.getDirectory);
          
        }
      })
    );
  }


  /**
  * 
  */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiAttributesService.edit(this.attrId).subscribe((response: Res) => {
        console.log('[RESPONSE] ATTR_EDIT: ', response);

        if (response != null) {

          this.attrEditable = response.result.uneditable;
          this.mandatory = response.result.mandatory;
          this.translation = response.result.translation;
          
          this.setDataInForm(response.result);
          this.initForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttributesService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] onCreate: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   */
   onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttributesService.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   * @param event 
   */
  multilingual(event): void {

    this.form.get('translation').setValue(event.target.checked);
  }


  /**
   * 
   */
  required(event): void {

    this.form.get('mandatory').setValue(event.target.checked);
  }


  /**
   * 
   * @param field 
   * @param type 
   * @returns 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


}
